/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".advanced-search[_ngcontent-%COMP%]{color:#025072;color:var(--customPrimary);font-size:1rem;cursor:pointer}.size-label[_ngcontent-%COMP%]{width:100%}.position-switcher[_ngcontent-%COMP%]{padding-bottom:1rem;display:block}.ms-ie-left[_ngcontent-%COMP%]{display:table}.ms-ie-left[_ngcontent-%COMP%] > .position-switcher[_ngcontent-%COMP%]{margin-left:-24.5px!important}.ms-ie-fake-mb[_ngcontent-%COMP%]{padding-bottom:40px}"];
export { styles as styles };
